<template>
<div
  class="mouth"
  :class="{
    'mouth-open': mouthState === 'open',
    'mouth-open-teeth': mouthState === 'open-teeth',
    'mouth-teeth': mouthState === 'teeth',
    'mouth-o': mouthState === 'o'  
  }"
>
  <div class="mouth__closed"></div>
  <div class="mouth__open"></div>
  <div class="mouth__open-teeth"></div>
  <div class="mouth__teeth"></div>
  <div class="mouth__o"></div>
</div>
</template>

<script>
export default {
  name: 'mouth',
  data () {
    return {
      mouthState: '',
      mouthTimeCounter: 0,
      mouthInterval: null,
      mouthIntervalPeriod: 500
    }
  },
  methods: {
    sing () {
      this.mouthState = ''
      this.mouthTimeCounter = 0
      clearInterval(this.mouthInterval)
      this.mouthInterval = setInterval(() => {
        if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 5) === 0) {
          this.mouthState = 'open'
        } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 4) === 0) {
          this.mouthState = 'teeth'
        } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 3) === 0) {
          this.mouthState = ''
        } else if (this.mouthTimeCounter % (this.mouthIntervalPeriod * 2) === 0) {
          this.mouthState = 'open-teeth'
        } else if (this.mouthTimeCounter % this.mouthIntervalPeriod === 0) {
          this.mouthState = 'o'
        }
        if (this.mouthTimeCounter >= this.speakDuration) {
          this.mouthState = ''
          this.mouthTimeCounter = 0
          clearInterval(this.mouthInterval)
        } else {
          this.mouthTimeCounter += this.mouthIntervalPeriod
        }
      }, this.mouthIntervalPeriod)
    },
    stopSinging () {
      this.mouthState = ''
      this.mouthTimeCounter = 0
      clearInterval(this.mouthInterval)
    }
  },
  beforeDestroy () {
    clearInterval(this.mouthInterval)
  }
}
</script>

<style lang="scss">
.mouth {
  position: relative;
  width: fluid(106px);
  height: fluid(56px);
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &__closed {
    position: absolute;
    top: 0;
    left: 0;
    width: fluid(106px);
    height: fluid(56px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-closed.svg');
  }
  &__open {
    display: none;
    position: absolute;
    top: 0;
    left: fluid(4px);
    width: fluid(106px);
    height: fluid(65px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-open.svg');
  }
  &__open-teeth {
    display: none;
    position: absolute;
    top: fluid(-5px);
    left: 0;
    width: fluid(109px);
    height: fluid(60px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-open-teeth.svg');
  }
  &__teeth {
    display: none;
    position: absolute;
    top: 0;
    left: fluid(14px);
    width: fluid(96px);
    height: fluid(62px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-teeth.svg');
  }
  &__o {
    display: none;
    position: absolute;
    top: fluid(-3px);
    left: fluid(20px);
    width: fluid(106px);
    height: fluid(68px);
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;
    background-image: url('~@/assets/img/pearlie-sue-mouth-o.svg');
  }
  &.mouth-open {
    .mouth {
      &__closed {
        display: none;
      }
      &__open {
        display: block;
      }
    }
  }
  &.mouth-open-teeth {
    .mouth {
      &__closed {
        display: none;
      }
      &__open-teeth {
        display: block;
      }
    }
  }
  &.mouth-teeth {
    .mouth {
      &__closed {
        display: none;
      }
      &__teeth {
        display: block;
      }
    }
  }
  &.mouth-o {
    .mouth {
      &__closed {
        display: none;
      }
      &__o {
        display: block;
      }
    }
  }
}
</style>